import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcDelete(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.25 12a8.25 8.25 0 1 0-16.5 0 8.25 8.25 0 0 0 16.5 0m-5.953-3.355a.75.75 0 0 1 1.06 1.06l-2.302 2.302 2.295 2.295a.75.75 0 1 1-1.06 1.06l-2.296-2.295L9.7 15.362a.75.75 0 0 1-1.06-1.06l2.295-2.295-2.302-2.302a.75.75 0 1 1 1.06-1.06l2.302 2.301zM21.75 12c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25s9.75 4.365 9.75 9.75"
  }));
}
var IcDelete = createNolIcon(/*#__PURE__*/forwardRef(SvgIcDelete));

export { IcDelete as I };
